function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.795 3.912l-.883.883.147.146L7.117 8 4.06 11.059l-.147.146.883.883.146-.147L8 8.883l3.059 3.058.146.147.883-.883-.147-.146L8.883 8l3.058-3.059.147-.146-.883-.883-.146.147L8 7.117 4.941 4.06z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    color: "#000000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "gray",
    fillRule: "evenodd"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLogo);
export default __webpack_public_path__ + "static/media/close_logo.7bf292158ee7464ea6910f6d873020b1.svg";
export { ForwardRef as ReactComponent };